import React, { useEffect, useState } from "react";
import ImageWithFallback from "../Components/ImageWithFallback";
import ApiRequest, { baseurl } from "../Common/restservice";
import { useNavigate, Link, useLocation, json } from "react-router-dom";
import { errorToast, successToast } from "../Common/showtoast";
import banner from "../Assets/Images/homebanner.jpg";
import { FaPenToSquare } from "react-icons/fa6";
import Personal from "./Profile/Personal";
import Education from "./Profile/Education";
import Employment from "./Profile/Employment";
import ContactProfile from "./Profile/Contactprofile";
import WorkTime from "./Profile/Work";
import Additional from "./Profile/Additional";
import CompanyInformation from "./Profile/CompanyInformation";
import CompanyContact from "./Profile/Companycontact";
import Service from "./Profile/Service";
import AdditionalCompany from "./Profile/AdditionalCompany";
import Business from "./Profile/Business";
import Portfolio from "./Profile/Photos";
import Swal from "sweetalert2";

function Profile() {
  const [currentDiv, setCurrentDiv] = useState(
    localStorage.getItem("usertypecategory") === "Individual"
      ? "personal"
      : "company"
  );
  const [stateObj, setStateObj] = useState({});
  const navigate = useNavigate();

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const errtext = params.get("err");
  useEffect(() => {
    if (errtext)
      Swal.fire({
        title: "Update your profile",
        text: errtext,
      });
  }, [errtext]);
  useEffect(() => {
    GetMyProfile();
  }, []);
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("MyProfile.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };
  const UpdateProfile = async (e) => {
    const regex = /['&%;\(\)\\]/g;
    // stateObj.fullname = "Chisel Montessori School";
    let data = JSON.stringify(stateObj).replace(regex, "");
    console.log(localStorage.getItem("usertypecategory") === "Individual"
      ? "editprofile_freelancer.asp"
      : "editprofile_company.asp");
    console.log(data);
    console.log(localStorage.getItem("token"))
    let res = await ApiRequest(
      localStorage.getItem("usertypecategory") === "Individual"
        ? "editprofile_freelancer.asp"
        : "editprofile_company.asp",
      "POST",
      data,
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    successToast(res.message);
    GetMyProfile();
  };
  const UpdateProfilePic = async (e) => {
    const formData = new FormData();
    formData.append("profileimage", e.target.files[0]);
    let res = await ApiRequest(
      "uploadprofileimg.asp",
      "POST",
      formData,
      { Authorization: localStorage.getItem("token") },
      false
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    GetMyProfile();
    successToast(res.message);
  };
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Profile</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    User Profile
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sptb">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div class="card">
                <div class="card-body pattern-1">
                  <div class="wideget-user">
                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <div class="wideget-user-desc text-center">
                          <div class="wideget-user-img justify-content-center text-center d-flex">
                            <label htmlFor="profilepic">
                              <div
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  maxWidth: 100,
                                }}
                              >
                                <ImageWithFallback
                                  src={baseurl + stateObj.profilepic}
                                  alt="img"
                                  style={{ height: "100px", width: 100 }}
                                />
                                <FaPenToSquare
                                  className="text-primary"
                                  style={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    backgroundColor: "white",
                                  }}
                                />
                                <input
                                  type="file"
                                  multiple={false}
                                  accept="image/jpg,image/jpeg"
                                  id="profilepic"
                                  style={{ display: "none" }}
                                  name="profilepic"
                                  className="form-control"
                                  onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                      UpdateProfilePic(e);
                                    }
                                  }}
                                />
                              </div>
                            </label>
                          </div>
                          <div class="user-wrap wideget-user-info">
                            <label class="text-white">
                              <h4 class="font-weight-bold">
                                {stateObj.fullname}({stateObj.username})
                              </h4>
                            </label>
                            <div class="wideget-user-rating">
                              {[1, 2, 3, 4, 5].map((item) => {
                                return stateObj.avg_star_rating &&
                                  parseInt(stateObj.avg_star_rating) >= item ? (
                                  <i
                                    key={item}
                                    className="fa fa-star text-warning"
                                  ></i>
                                ) : (
                                  <i
                                    key={item}
                                    className="fa fa-star text-white"
                                  ></i>
                                );
                              })}
                              <span class="text-white ms-1">
                                {stateObj.avg_star_rating || 0} (
                                {stateObj.number_of_review || 0} Reviews)
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12 col-md-12 text-center">
                        <div class="wideget-user-info ">
                          <div class="wideget-user-icons mt-2">
                            <a
                              href={stateObj.facebookprofile?.startsWith("http")
                                ? stateObj.facebookprofile
                                : `https://${stateObj.facebookprofile}`}
                              target="_blank"
                              rel="noreferrer"
                              class="facebook-bg mt-0"
                            >
                              <i class="fa fa-facebook"></i>
                            </a>
                            <a
                              href={stateObj.instaprofile?.startsWith("http")
                                ? stateObj.instaprofile
                                : `https://${stateObj.instaprofile}`}
                              rel="noreferrer"
                              target="_blank"
                              class="bg-pink"
                            >
                              <i class="fa fa-instagram"></i>
                            </a>
                            <a
                              href={stateObj.linkedinprofile?.startsWith("http")
                                ? stateObj.linkedinprofile
                                : `https://${stateObj.linkedinprofile}`}
                              target="_blank"
                              rel="noreferrer"
                              class="bg-info text-white"
                            >
                              <i class="fa fa-linkedin"></i>
                            </a>
                            <a
                              href={stateObj.website?.startsWith("http")
                                ? stateObj.website
                                : `https://${stateObj.website}`}
                              target="_blank"
                              rel="noreferrer"
                              class="bg-primary text-white"
                            >
                              <i class="fa fa-globe"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="wideget-user-tab">
                    <div class="tab-menu-heading">
                      <div class="tabs-menu1">
                        {localStorage.getItem("usertypecategory") ===
                          "Individual" ? (
                          <ul class="nav">
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("personal");
                                }}
                                class={
                                  currentDiv === "personal"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Personal Information
                              </label>
                            </li>
                            <li>
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("education");
                                }}
                                class={
                                  currentDiv === "education"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                About
                              </label>
                            </li>
                            <li>
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("employment");
                                }}
                                class={
                                  currentDiv === "employment"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Professional Details
                              </label>
                            </li>
                            <li>
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("contact");
                                }}
                                class={
                                  currentDiv === "contact"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Contact
                              </label>
                            </li>
                            <li>
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("worktime");
                                }}
                                class={
                                  currentDiv === "worktime"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Availability & Pricing
                              </label>
                            </li>
                            <li>
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("additional");
                                }}
                                class={
                                  currentDiv === "additional"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Additional Details
                              </label>
                            </li>
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("photos");
                                }}
                                class={
                                  currentDiv === "photos"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Gallery
                              </label>
                            </li>
                          </ul>
                        ) : (
                          <ul class="nav">
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("company");
                                }}
                                class={`${currentDiv === "company"
                                  ? "active p-3 cursor-pointer mb-0"
                                  : "p-3 cursor-pointer mb-0"
                                  }`}
                              >
                                Company Information
                              </label>
                            </li>
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("companycontact");
                                }}
                                class={
                                  currentDiv === "companycontact"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Contact Information
                              </label>
                            </li>
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("business");
                                }}
                                class={
                                  currentDiv === "business"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Business
                              </label>
                            </li>
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("service");
                                }}
                                class={
                                  currentDiv === "service"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Product / Service
                              </label>
                            </li>
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("additionalcompany");
                                }}
                                class={
                                  currentDiv === "additionalcompany"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Additional Information
                              </label>
                            </li>
                            <li class="">
                              <label
                                onClick={(e) => {
                                  setCurrentDiv("photos");
                                }}
                                class={
                                  currentDiv === "photos"
                                    ? "active p-3 cursor-pointer mb-0"
                                    : "p-3 cursor-pointer mb-0"
                                }
                              >
                                Gallery
                              </label>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span className="text-danger">
                * Note : Don’t use any special characters like ( ' & " % ; ( ) \ )
              </span>

              <div class="card mt-5">
                <div class="card-body">
                  {currentDiv === "personal" && (
                    <Personal
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "education" && (
                    <Education
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "employment" && (
                    <Employment
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "contact" && (
                    <ContactProfile
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "worktime" && (
                    <WorkTime
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "additional" && (
                    <Additional
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "company" && (
                    <CompanyInformation
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "companycontact" && (
                    <CompanyContact
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "business" && (
                    <Business
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "service" && (
                    <Service
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "additionalcompany" && (
                    <AdditionalCompany
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                  {currentDiv === "photos" && (
                    <Portfolio
                      stateObj={stateObj}
                      setStateObj={setStateObj}
                      UpdateProfile={UpdateProfile}
                      setCurrentDiv={setCurrentDiv}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Profile;
